import React, { useEffect, useState } from 'react';
import Alert from '@cloudscape-design/components/alert';
import Box from '@cloudscape-design/components/box';
import ColumnLayout from '@cloudscape-design/components/column-layout';
import Container from '@cloudscape-design/components/container';
import ContentLayout from '@cloudscape-design/components/content-layout';
import Header from '@cloudscape-design/components/header';
import Spinner from '@cloudscape-design/components/spinner';
import { apiJson } from '../utils/api';

interface DashboardData {
  total_users: number;
  total_sightings: number;
  registry_aircraft: number;
}

const Metric: React.FC<{ label: string; value: number }> = ({ label, value }) => (
  <div>
    <Box variant="awsui-key-label">{label}</Box>
    <Box variant="h1">{value.toLocaleString()}</Box>
  </div>
);

const DashboardPage: React.FC = () => {
  const [data, setData] = useState<DashboardData | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    apiJson<DashboardData>('/admin/dashboard')
      .then(setData)
      .catch((e: Error) => setError(e.message));
  }, []);

  return (
    <ContentLayout header={<Header variant="h1">Dashboard</Header>}>
      {error && (
        <Alert type="error" header="Failed to load metrics">
          {error}
        </Alert>
      )}
      <Container header={<Header variant="h2">Platform overview</Header>}>
        {!data && !error ? (
          <Box textAlign="center" padding="l">
            <Spinner />
          </Box>
        ) : data ? (
          <ColumnLayout columns={3} variant="text-grid">
            <Metric label="Users" value={data.total_users} />
            <Metric label="Sightings logged" value={data.total_sightings} />
            <Metric label="Aircraft in FAA registry" value={data.registry_aircraft} />
          </ColumnLayout>
        ) : null}
      </Container>
    </ContentLayout>
  );
};

export default DashboardPage;
